import { FC, useCallback, useMemo, useState } from 'react'
import {
  Heading,
  Icon,
  Modal,
  ModalActions,
  ModalContent,
  RoundedButton,
  Switch,
  ThinModalLayout,
} from '../../shared'
import { SamAlertModalProps } from './SamAlertModal.model'
import { removeAllHtmlTags, sanitizeToBasicHtml } from '../../../misc/sanitizer.utilities'
import styles from './SamAlertModal.module.scss'
import RoleRestriction from '../../../containers/RoleRestriction'
import { Roles } from '../../../model/Roles'

export const SamAlertModal: FC<SamAlertModalProps> = ({ alerts, isUnmounting, onClose }) => {
  const [disableAlerts, setDisableAlerts] = useState(false)

  const sanitizedAlerts = useMemo(
    () =>
      alerts.map(({ content, title }) => ({
        content: sanitizeToBasicHtml(content),
        title: removeAllHtmlTags(title),
      })),
    [alerts],
  )

  const handleValid = useCallback(() => {
    onClose(disableAlerts)
    setDisableAlerts(false)
  }, [disableAlerts, onClose])

  const handleClose = useCallback(() => {
    onClose(false)
    setDisableAlerts(false)
  }, [onClose])

  return (
    <Modal isUnmounting={isUnmounting} onClickOutside={handleClose}>
      <ThinModalLayout size="medium">
        <div className={styles.samAlertModalContainer}>
          <ModalContent>
            <Icon size="mega" icon="alert" />
            <Heading size={3}>Systèmes d'aide à la décision indexée par médicaments (SAM)</Heading>
          </ModalContent>
          <div className={styles.samAlertModalAlerts}>
            {sanitizedAlerts.map(({ content, title }, index) => (
              <div key={index} className={styles.samAlertModalAlert}>
                <span
                  className={styles.samAlertModalAlertTitle}
                  dangerouslySetInnerHTML={{ __html: title }}
                />
                <span
                  className={styles.underlineAchildren}
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </div>
            ))}
          </div>
          <ModalActions>
            <div className={styles.samAlertModalAlertDeactivation}>
              <RoleRestriction roles={[Roles.DOCTOR]}>
                <Switch
                  name={`Ne plus afficher les alertes SAM de ce type (${alerts
                    .map(({ samTypeDisplayName }) => samTypeDisplayName)
                    .join(', ')})`}
                  checked={disableAlerts}
                  onChange={setDisableAlerts}
                  testId="switch-sam-disable"
                />
              </RoleRestriction>
            </div>
            <RoundedButton
              theme="invalid"
              label="Fermer"
              onClick={handleValid}
              testId="button-sam-close"
            />
          </ModalActions>
        </div>
      </ThinModalLayout>
    </Modal>
  )
}
